import React, { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import MyAccount from 'layouts/MyAccount';
import { withAuth } from 'features/auth/withAuth';

export const tabItems = [
  {
    label: 'General Information',
    path: '/my-account/profile/general',
  },
  {
    label: 'Delete my Account',
    path: '/my-account/profile/privacy',
  },
];

function Profile() {
  const router = useRouter();

  useEffect(() => {
    router.push('/my-account/profile/general');
  }, []);

  return (
    <MyAccount>
      <Head>
        <title>Profile - My Account - Mind The Graph</title>
      </Head>
    </MyAccount>
  );
}

export default withAuth(Profile);
